/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdministrationUsersInformation } from '../../models/administration-users-information';
import { KeyType } from '../../models/key-type';

export interface GetAdministrationOrganizationUsers$Params {
  organizationKey: KeyType;
}

export function getAdministrationOrganizationUsers(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUsersInformation>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationUsers.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdministrationUsersInformation>;
    })
  );
}

getAdministrationOrganizationUsers.PATH = '/administration/organizations/{organizationKey}/users';
